import { createReducer } from '@reduxjs/toolkit';
import { addTaxDocuments, setTaxDocuments } from 'data/actions/TaxDocuments';
import { TaxDocument } from 'data/models/taxDocuments';

export interface State {
  taxDocuments: TaxDocument[];
}

export const initialState: State = {
  taxDocuments: [],
};

export default createReducer(initialState, builder => {
  builder.addCase(setTaxDocuments, (state, action) => {
    state.taxDocuments = [...action.payload];
  });
  builder.addCase(addTaxDocuments, (state, action) => {
    state.taxDocuments.push(...action.payload);
  });
});
